import logger from 'itrvl-logger';

// Setup logger
logger.setup(false, true);
window.logger = logger;

// Dynamic so it loads after logger.setup above: a static import is hoisted, and bootstrap.js
// builds a module-scope logger that must see the configured default level. The catch keeps a
// throw during bootstrap's evaluation visible: unhandled, it is a blank page and a silent
// rejection.
import('./bootstrap').catch(err => {
  logger('src/index.js').error('Failed to load bootstrap', err);
});
